module.exports = "https://cdn.hellotech.com/client-assets/computer-with-sandy-background_1a1c63e111214cfb31206d3e11763534.png";